module.exports = __webpack_public_path__ + "img/airplane2.009cd553.png";